import {
  type PhoneNumber,
  PhoneNumberFormat,
  PhoneNumberType,
  PhoneNumberUtil,
  type RegionCode,
} from 'google-libphonenumber';

export type PhoneNumberOrString = string | PhoneNumber;
export const PhoneUtil = PhoneNumberUtil.getInstance();

export const formatPhoneNum = (phoneNum: string) => {
  if (!phoneNum) return '';
  try {
    return PhoneUtil.format(PhoneUtil.parse(phoneNum), PhoneNumberFormat.INTERNATIONAL);
  } catch {
    return phoneNum;
  }
};

export const getFormattedExampleNumber = (isoCode: RegionCode) =>
  PhoneUtil.format(PhoneUtil.getExampleNumberForType(isoCode, PhoneNumberType.MOBILE), PhoneNumberFormat.INTERNATIONAL);

const VALID_VALIDATION_RESULTS = [
  PhoneNumberUtil.ValidationResult.IS_POSSIBLE,
  PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY,
] as const;

export const isValidNum = (num: string) => {
  try {
    const validationResult = PhoneUtil.isPossibleNumberWithReason(PhoneUtil.parse(num));
    return VALID_VALIDATION_RESULTS.includes(validationResult as (typeof VALID_VALIDATION_RESULTS)[number]);
  } catch (e) {
    return false;
  }
};

export const getEmojiFromIsoCode = (isoCode: RegionCode) =>
  isoCode
    .toUpperCase()
    .split('')
    .map((char) =>
      // Get the regional indicator symbol by offsetting from the ASCII code of 'A'
      String.fromCodePoint(char.charCodeAt(0) + 127397))
    .join('');

export const getIsoCodeFromPhone = (phoneNum: PhoneNumberOrString) => {
  if (typeof phoneNum === 'string') phoneNum = PhoneUtil.parse(phoneNum);
  return PhoneUtil.getRegionCodeForNumber(phoneNum);
};

export const getCountryPrefix = (isoCode: RegionCode) => `+${PhoneUtil.getCountryCodeForRegion(isoCode)}`;
